export default "__VITE_ASSET__BdYPe1$0__"